// FormDataContext.js

import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

const FormDataContext = createContext();

const FormDataProvider = ({ children }) => {
  const [currentStudentStatus, setCurrentStudentStatus] = useState([
    "28", "29", "30", "31", "32", "33",
  ]);
  const [yourInterests, setYourInterests] = useState([
    "22", "23", "24", "25", "27", "34"
  ])
  const [degrees, setDegrees] = useState([]);
  const [degreesDataLoaded, setDegreesDataLoaded] = useState(false);
  const [isSubmitComplete, setIsSubmitComplete] = useState(false);
  const [isFormDataChanged, setIsFormDataChanged] = useState(false);
  const [isFormCompleted, setIsFormCompleted] = useState(false);
  const [isAccountConfirmed, setIsAccountConfirmed] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLocationsAllSelected, setIsLocationsAllSelected] = useState(false);
  const [subscribeLink, setSubscribeLink] = useState('');
  const [unsubscribeLink, setUnsubscribeLink] = useState('');
  const [initialPreferencesData, setInitialPreferencesData] = useState({});
  const [initialLocationsAll, setInitialLocationsAll] = useState(undefined);
  const [preferencesFormDisabled, setPreferencesFormDisabled] = useState(true);
  const [intakeHeroImageUrl, setIntakeHeroImageUrl] = useState('');
  const [intakeHeroOverlayHeading, setIntakeHeroOverlayHeading] = useState('');
  const [intakeIntroHeading, setIntakeIntroHeading] = useState('');
  const [intakeIntroText, setIntakeIntroText] = useState('');
  const [currentUserUid, setCurrentUserUid] = useState('');
  const [currentUserEmail, setCurrentUserEmail] = useState('');
  const [email, setEmail] = useState('');
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [intakeData, setIntakeData] = useState({});
  const [intakeDataLoaded, setIntakeDataLoaded] = useState(false);
  const [isFormDataLoaded, setIsFormDataLoaded] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [attributes, setAttributes] = useState([]);
  const [attributesAll, setAttributesAll] = useState([]);
  const [attributesDataLoaded, setAttributesDataLoaded] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [included, setIncluded] = useState([]);
  const [excluded, setExcluded] = useState([]);
  const [showCurrentStudent, setCurrentStudent] = useState(false);
  const [suppress, setSuppress] = useState(["6", "22", "23", "24", "25", "27"]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [locations, setLocations] = useState([]);
  const [locationDataLoaded, setLocationDataLoaded] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedLocationsAll, setSelectedLocationsAll] = useState('');
  const [occupations, setOccupations] = useState([]);
  const [occupationDataLoaded, setOccupationDataLoaded] = useState(false);
  const [selectedOccupations, setSelectedOccupations] = useState([]);
  const [expandedOccupations, setExpandedOccupations] = useState([]);
  const [selectedOccupationsX, setSelectedOccupationsX] = useState([]);
  const [expandedOccupationsX, setExpandedOccupationsX] = useState([]);
  const [jobCodes, setJobCodes] = useState([]);
  const [schools, setSchools] = useState([]);
  const [schoolDataLoaded, setSchoolDataLoaded] = useState(false);
  // const [gpa, setGPA] = useState("");
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [selectedDegrees, setSelectedDegrees] = useState([]);
  const [optedOut, setOptedOut] = useState(false);
  const [displayPages, setDisplayPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [emailIncluded, setEmailIncluded] = useState([]);
  const [emailExcluded, setEmailExcluded] = useState([]);
  const [startDateX, setStartDateX] = useState(null);
  const [endDateX, setEndDateX] = useState(null);
  const [locationsX, setLocationsX] = useState([]);
  const [locationDataLoadedX, setLocationDataLoadedX] = useState(false);
  const [selectedLocationsX, setSelectedLocationsX] = useState([]);
  const [jobCodesX, setJobCodesX] = useState([]);
  const [schoolsX, setSchoolsX] = useState([]);
  const [schoolDataLoadedX, setSchoolDataLoadedX] = useState(false);
  // const [gpaX, setGPAX] = useState("");
  const [selectedSchoolsX, setSelectedSchoolsX] = useState([]);
  const [selectedDegreesX, setSelectedDegreesX] = useState([]);
  const [reportOptions, setReportOptions] = useState({
    schools: false,
    locations: false,
    date: false,
    email: false,
    attributes: false,
    occupations: false,
  });
  const headingFieldsData = [
    { name: "id", label: "ID" },
    { name: "email", label: "Email" },
    { name: "registrationDate", label: "Registration Date" },
    { name: "optedOut", label: "Opted-Out" },
    { name: "attributes", label: "Attributes" },
    { name: "locations", label: "Locations" },
    { name: "occupationalAreas", label: "Occupational Areas" },
    { name: "degree", label: "Degree" },
    { name: "school", label: "School" },
  ];

  // Set the names of checkboxes you want to be initially checked
  const initiallyCheckedFields = ["id", "email", "registrationDate"];

  const initialCheckedState = headingFieldsData.reduce(
    (acc, field) => ({
      ...acc,
      [field.name]: initiallyCheckedFields.includes(field.name),
    }),
    {}
  );

  const [checkedHeadings, setCheckedHeadings] = useState(initialCheckedState);

  useEffect(() => {
    const fetchAttributesData = async () => {
      // Fetch attributes data from the server using axios and set the state
      try {
        const response = await axios.get("/api/attributes-data");
        const attributesData = response.data;
        attributesData.sort(
          (attrA, attrB) => attrA.weight - attrB.weight
        );
        const filteredAttributesData = attributesData.filter(
          (attr) => !suppress.includes(attr.attribute_id)
        );
        setAttributesAll(attributesData);
        setAttributes(filteredAttributesData);
        setAttributesDataLoaded(true);
      } catch (error) {
        console.error("Error fetching attributes:", error);
        setAttributesDataLoaded(true);
      }
    };

    const fetchLocationData = async () => {
      // Fetch location data from the server using axios and set the state
      try {
        const response = await axios.get("/api/v1/locations");
        const dataFromAPI = response.data;
        const locationsData = dataFromAPI.map((location) => ({
          id: location.id,
          name: location.name,
          extendedName: location.extendedName,
          enabled: location.enabled,
          international: location.international,
          stateName: location.stateName
        }));
        locationsData.sort();
        setLocations(locationsData);
        setLocationDataLoaded(true);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    const fetchOccupationData = async () => {
      // Fetch occupation data from the server using axios and set the state
      const API_URL = "/api/occupations-data";
      try {
        // await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate delay for API call (remove in real implementation)
        const response = await axios.get(API_URL);
        const occupationsData = response.data;
        setOccupations(occupationsData);
        setJobCodes([]);
        setOccupationDataLoaded(true);
      } catch (error) {
        console.error("Error fetching occupations:", error);
        setOccupationDataLoaded(true);
      }
    };

    const fetchSchoolData = async () => {
      // Fetch school data from the server using axios and set the state
      try {
        const response = await axios.get("/api/v1/schools");
        const dataFromAPI = response.data;
        const schoolsData = dataFromAPI.map((school) => ({
          id: school.id,
          name: school.name,
        }));
        setSchools(schoolsData);
        setSchoolDataLoaded(true);
      } catch (error) {
        console.error("Error fetching schools:", error);
        setSchoolDataLoaded(true); // Set dataLoaded to true even if there's an error to prevent the component from getting stuck in a loading state.
      }
    };

    const fetchDegreesData = async () => {
      try {
        const response = await axios.get("/api/degrees-data");
        const dataFromAPI = response.data;
        setDegrees(dataFromAPI);
      } catch (error) {
        console.error("Error fetching degrees:", error);
      } finally {
        setDegreesDataLoaded(true);
      }
    };

    const fetchTemplatesData = async () => {
      // Fetch attributes data from the server using axios and set the state
      try {
        const response = await axios.get("/api/templates");
        const filteredData = response.data.filter((item) =>
          item.startsWith("roa-")
        );
        setTemplates(filteredData);
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    };
    // Fetch data for each context
    fetchAttributesData();
    fetchLocationData();
    fetchOccupationData();
    fetchSchoolData();
    fetchIntakeData();
    fetchDegreesData();
    // fetchTemplatesData();
  }, []);

  const fetchIntakeData = async () => {
    try {
      const response = await axios.get("/api/v1/intake-data");
      const dataFromAPI = response.data;
      const {heroImageUrl, heroOverlayHeading, introHeading, introText, userState } = { ... dataFromAPI };
      if (heroImageUrl) {
        setIntakeHeroImageUrl(heroImageUrl);
      }
      if (heroOverlayHeading) {
        setIntakeHeroOverlayHeading(heroOverlayHeading);
      }
      if (introHeading) {
        setIntakeIntroHeading(introHeading);
      }
      if (introText) {
        setIntakeIntroText(introText);
      }
      if (userState) {
        if (userState.authenticated) {
          if (userState.uid) {
            setCurrentUserUid(userState.uid);
          }
          if (userState.email) {
            setCurrentUserEmail(userState.email);
            setPreferencesFormDisabled(false);
          }
          if (userState.preferences) {
            setInitialPreferencesData(userState.preferences);
            if (userState.preferences.occupations) {
              const initialOccupations = userState.preferences.occupations;
              if (initialOccupations.length > 0) {
                setSelectedOccupations(initialOccupations);
              }
            }
            if (userState.preferences.locations) {
              const initialLocations = userState.preferences.locations;
              if (initialLocations.length > 0) {
                setSelectedLocations(initialLocations);
              }
            }
            if (userState.preferences.attributes) {
              const initialAttributes = userState.preferences.attributes;
              if (initialAttributes.length > 0) {
                setSelectedAttributes(initialAttributes);
              }
            }
            if (userState.preferences.degrees) {
              const initialDegrees = userState.preferences.degrees;
              if (initialDegrees.length > 0) {
                setSelectedDegrees(initialDegrees);
              }
            }
            if (userState.preferences.schools) {
              const initialSchools = userState.preferences.schools;
              if (initialSchools.length > 0) {
                setSelectedSchools(initialSchools);
              }
            }
            let locationsAll = userState.preferences.locationsAll;
            setInitialLocationsAll(locationsAll);
            let locationsAllSelected = userState.preferences.locationsAllSelected;
            if (!locationsAll && !locationsAllSelected) {
              locationsAll = '';
            }
            if (locationsAll === true) {
              locationsAllSelected = true;
            }
            setSelectedLocationsAll(locationsAll);
            setIsLocationsAllSelected(locationsAllSelected);
            if (userState.preferences.optedIn) {
              setIsSubscribed(true);
            }
            if (userState.preferences.formCompleted) {
              setIsFormCompleted(true);
            }
          }
          if (userState.subscribe) {
            setSubscribeLink(userState.subscribe);
          }
          if (userState.unsubscribe) {
            setUnsubscribeLink(userState.unsubscribe);
          }
        }
      }
      setIntakeData(dataFromAPI);
    } catch (error) {
      console.error("Error fetching intake data:", error);
    } finally {
      setIntakeDataLoaded(true);
    }
  };

  const resetForm = () => {
    // Reset all form-related state values to their initial values
    setIncluded([]);
    setExcluded([]);
    setCurrentStudent(false);
    setSuppress(["6", "22", "23", "24", "25", "27"]);
    setStartDate(null);
    setEndDate(null);
    setSelectedLocations([]);
    setJobCodes([]);
    setJobCodesX([]);
    // setGPA("");
    setSelectedSchools([]);
    setSelectedDegrees([]);
    setStartDateX(null);
    setEndDateX(null);
    setSelectedLocationsX([]);
    setJobCodesX([]);
    // setGPAX("");
    setSelectedSchoolsX([]);
    setSelectedDegreesX([]);
    setReportOptions({
      schools: false,
      locations: false,
      date: false,
      email: false,
      attributes: false,
      occupations: false,
    });
    setOptedOut(false);
    setDisplayPages(10);
    setEmailExcluded([]);
    setEmailIncluded([]);
    setFilterName("");
    setSelectedOccupations([]);
    setSelectedOccupationsX([]);
    setExpandedOccupations([]);
    setExpandedOccupationsX([]);
  };

  return (
    <FormDataContext.Provider
      value={{
        isSubmitComplete,
        setIsSubmitComplete,
        isFormDataChanged,
        setIsFormDataChanged,
        isFormCompleted,
        isSubscribed,
        setIsSubscribed,
        isLocationsAllSelected,
        setIsLocationsAllSelected,
        subscribeLink,
        setSubscribeLink,
        unsubscribeLink,
        setUnsubscribeLink,
        isAccountConfirmed,
        setIsAccountConfirmed,
        initialPreferencesData,
        initialLocationsAll,
        currentUserUid,
        setCurrentUserUid,
        currentUserEmail,
        setCurrentUserEmail,
        intakeData,
        setIntakeData,
        preferencesFormDisabled,
        setPreferencesFormDisabled,
        intakeHeroImageUrl,
        setIntakeHeroImageUrl,
        intakeHeroOverlayHeading,
        setIntakeHeroOverlayHeading,
        intakeIntroHeading,
        setIntakeIntroHeading,
        intakeIntroText,
        setIntakeIntroText,
        intakeDataLoaded,
        setIntakeDataLoaded,
        isFormDataLoaded,
        setIsFormDataLoaded,
        attributes,
        attributesAll,
        attributesDataLoaded,
        selectedAttributes,
        setSelectedAttributes,
        degrees,
        setDegrees,
        degreesDataLoaded,
        email,
        setEmail,
        currentPage,
        displayPages,
        emailExcluded,
        emailIncluded,
        endDate,
        endDateX,
        excluded,
        // gpa,
        // gpaX,
        included,
        jobCodes,
        jobCodesX,
        locationDataLoaded,
        locationDataLoadedX,
        locations,
        locationsX,
        occupationDataLoaded,
        occupations,
        optedOut,
        reportOptions,
        schoolDataLoaded,
        schoolDataLoadedX,
        schools,
        schoolsX,
        selectedDegrees,
        selectedDegreesX,
        selectedLocationsAll,
        selectedLocations,
        selectedLocationsX,
        selectedSchools,
        selectedSchoolsX,
        showCurrentStudent,
        startDate,
        startDateX,
        suppress,
        checkedHeadings,
        headingFieldsData,
        filterName,
        selectedOccupations,
        selectedOccupationsX,
        expandedOccupations,
        expandedOccupationsX,
        templates,
        currentStudentStatus,
        setCurrentStudentStatus,
        yourInterests,
        setYourInterests,
        setCurrentPage,
        setCurrentStudent,
        setDisplayPages,
        setEmailExcluded,
        setEmailIncluded,
        setEndDateX,
        setExcluded,
        // setGPA,
        // setGPAX,
        setIncluded,
        setJobCodesX,
        setLocationDataLoadedX,
        setLocationsX,
        setOptedOut,
        setReportOptions,
        setSchoolDataLoadedX,
        setSchoolsX,
        setSelectedDegrees,
        setSelectedDegreesX,
        setSelectedLocationsAll,
        setSelectedLocations,
        setSelectedLocationsX,
        setSelectedSchools,
        setSelectedSchoolsX,
        setStartDateX,
        setEndDate,
        setStartDate,
        setJobCodes,
        setCheckedHeadings,
        setFilterName,
        resetForm,
        removeExcludedEmail: (index) =>
          setEmailExcluded((prevEmailList) =>
            prevEmailList.filter((_, i) => i !== index)
          ),
        removeIncludedEmail: (index) =>
          setEmailIncluded((prevEmailList) =>
            prevEmailList.filter((_, i) => i !== index)
          ),
        setExpandedOccupations,
        setExpandedOccupationsX,
        setSelectedOccupations,
        setSelectedOccupationsX,
        fetchIntakeData,
      }}
    >
      {children}
    </FormDataContext.Provider>
  );
};

export { FormDataContext, FormDataProvider };
